import React from "react";
import { motion } from "framer-motion";
import {
  FaBookReader,
  FaBrain,
  FaLanguage,
  FaChartLine,
  FaFlask,
  FaUserFriends,
} from "react-icons/fa";

import primaryImg from "../assets/primary1.jpeg";


const highlights = [
  {
    title: "Concept-Based Learning",
    desc: "",
    icon: <FaBookReader />,
  },

  {
    title: "Language Excellence",
    desc: "",
    icon: <FaLanguage />,
  },

  {
    title: "Experiential Learning",
    desc: "",
    icon: <FaFlask />,
  },

  {
    title: "Critical Thinking",
    desc: "",
    icon: <FaBrain />,
  },

  {
    title: "Collaborative Learning",
    desc: "",
    icon: <FaUserFriends />,
  },

  {
    title: "Academic Foundation",
    desc: "",
    icon: <FaChartLine />,
  },
];


const Preparatory = () => {

return (

<section className="
relative 
w-full 
py-32 
overflow-hidden 
bg-gradient-to-br 
from-[#f8fbff] 
via-[#f5f7fc] 
to-[#eef4ff]
">


{/* BACKGROUND */}

<div className="
absolute 
top-[-120px] 
left-[-120px] 
w-[450px] 
h-[450px] 
bg-blue-200/20 
blur-3xl 
rounded-full
">
</div>


<div className="
absolute 
bottom-[-120px] 
right-[-120px] 
w-[450px] 
h-[450px] 
bg-[#d4af37]/10 
blur-3xl 
rounded-full
">
</div>



<div className="
max-w-[1550px] 
mx-auto 
px-6 
relative 
z-10
">



{/* HERO */}

<motion.div

initial={{opacity:0,y:40}}

whileInView={{opacity:1,y:0}}

transition={{duration:.7}}

viewport={{once:true}}

className="text-center mb-28"

>


<div className="
inline-flex 
items-center 
gap-3 
px-8 
py-4 
rounded-full 
bg-white 
border 
border-blue-100 
shadow-[0_15px_40px_rgba(0,0,0,0.05)]
mb-10
">


<span className="text-[#0b4a80] text-xl">

📘

</span>



<p className="
uppercase 
tracking-[6px] 
text-[#0b4a80] 
text-sm 
font-black
">

Preparatory Stage

</p>


</div>





<h1 className="
text-5xl 
md:text-7xl 
xl:text-8xl 
font-black 
text-[#07294d] 
leading-[1.08]
">


<span className="relative inline-block pb-8">


Preparatory

<br/>

Stage



<span className="
absolute 
left-1/2 
-translate-x-1/2 
bottom-1 
w-[105%] 
h-6 
bg-gradient-to-r 
from-blue-100 
via-blue-200 
to-blue-100 
rounded-full
">
</span>


</span>


</h1>



<p className="
text-gray-600 
text-xl 
leading-10 
mt-14
">


Grades III to V


</p>




<p className="
max-w-[1150px] 
mx-auto 
text-gray-600 
text-xl 
leading-10 
mt-10
">


Students transition smoothly into structured learning through inquiry,
exploration, and concept-based teaching that develops curiosity,
confidence, and independent thinking.


</p>



</motion.div>





{/* MAIN SECTION */}


<div className="
grid 
lg:grid-cols-2 
gap-14 
items-center 
mb-32
">



{/* IMAGE */}


<motion.div

initial={{opacity:0,x:-40}}

whileInView={{opacity:1,x:0}}

transition={{duration:.7}}

viewport={{once:true}}

>


<div className="
relative 
overflow-hidden 
rounded-[50px] 
shadow-[0_30px_100px_rgba(0,0,0,0.12)] 
group
">


<img

src={primaryImg}

alt="preparatory-stage"

className="
w-full 
h-[720px] 
object-cover 
group-hover:scale-105 
transition 
duration-700
"

/>



<div className="
absolute 
inset-0 
bg-gradient-to-t 
from-[#021427]/80 
via-transparent 
to-transparent
">
</div>





<div className="
absolute 
bottom-8 
left-8 
right-8 
bg-white/90 
backdrop-blur-xl 
rounded-[30px] 
p-8 
shadow-2xl
">


<h3 className="
text-3xl 
font-black 
text-[#07294d] 
mb-4
">

Building Strong Academic Foundations

</h3>


</div>


</div>


</motion.div>
{/* CONTENT SIDE */}

<motion.div

initial={{opacity:0,x:40}}

whileInView={{opacity:1,x:0}}

transition={{duration:.7}}

viewport={{once:true}}

>


<div className="
bg-white 
rounded-[50px] 
shadow-[0_30px_100px_rgba(0,0,0,0.08)] 
p-10 
md:p-14 
relative 
overflow-hidden
">


{/* TOP BAR */}

<div className="
absolute 
top-0 
left-0 
w-full 
h-[8px] 
bg-gradient-to-r 
from-[#0b4a80] 
via-blue-400 
to-[#0b4a80]
">
</div>



{/* BG DESIGN */}

<div className="
absolute 
top-[-70px] 
right-[-70px] 
w-[220px] 
h-[220px] 
border-[24px] 
border-blue-100 
rounded-full
">
</div>





{/* ICON */}

<div className="
w-24 
h-24 
rounded-[32px] 
bg-[#0b4a80] 
text-white 
flex 
items-center 
justify-center 
text-5xl 
shadow-2xl 
mb-10 
relative 
z-10
">

📘

</div>





<h2 className="
text-5xl 
font-black 
text-[#07294d] 
leading-tight 
mb-8 
relative 
z-10
">


Building Strong

<br/>

Academic Foundations


</h2>





<div className="
w-28 
h-[6px] 
bg-blue-200 
rounded-full 
mb-10 
relative 
z-10
">
</div>





<p className="
text-gray-600 
text-xl 
leading-10 
relative 
z-10
">


Students transition smoothly into structured learning through inquiry,
exploration, and concept-based teaching that develops curiosity,
confidence, and independent thinking.


</p>



</div>


</motion.div>



</div>







{/* ================= HIGHLIGHTS ================= */}


<motion.div

initial={{opacity:0,y:40}}

whileInView={{opacity:1,y:0}}

transition={{duration:.7}}

viewport={{once:true}}

className="text-center mb-20"

>


<h2 className="
text-5xl 
md:text-6xl 
font-black 
text-[#07294d] 
leading-tight
">


Highlights


</h2>



<div className="
w-28 
h-[6px] 
bg-[#d4af37] 
rounded-full 
mx-auto 
mt-8
">
</div>


</motion.div>







{/* CARDS */}

<div className="
grid 
md:grid-cols-2 
xl:grid-cols-3 
gap-10
">


{highlights.map((item,index)=>(


<motion.div

key={index}

initial={{opacity:0,y:40}}

whileInView={{opacity:1,y:0}}

transition={{
duration:.5,
delay:index*.08
}}

viewport={{once:true}}

whileHover={{
y:-12
}}

className="
group 
relative 
overflow-hidden 
rounded-[40px] 
bg-white 
shadow-[0_25px_80px_rgba(0,0,0,0.08)]
"


>


{/* TOP LINE */}

<div className="
absolute 
top-0 
left-0 
w-full 
h-[7px] 
bg-gradient-to-r 
from-[#0b4a80] 
via-blue-400 
to-[#0b4a80]
">
</div>





{/* NUMBER */}

<h1 className="
absolute 
top-4 
right-6 
text-[90px] 
font-black 
text-blue-50
">


0{index+1}


</h1>






<div className="
relative 
z-10 
p-10
">



{/* ICON */}

<div className="
w-20 
h-20 
rounded-[28px] 
bg-[#0b4a80] 
text-white 
flex 
items-center 
justify-center 
text-4xl 
shadow-2xl 
mb-8
">


{item.icon}


</div>






<h3 className="
text-3xl 
font-black 
text-[#07294d] 
mb-5 
leading-tight
">


{item.title}


</h3>





<div className="
w-20 
h-[5px] 
bg-blue-200 
rounded-full
">
</div>




</div>



</motion.div>


))}



</div>





</div>


</section>

);

};


export default Preparatory;